import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, updateForm } from 'store/data/forms';

export function useUpdateForm(): Operation<() => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.UPDATE_FORM);

	async function handler() {
		if (loading) return;
		if (error) resetError();

		await dispatch(updateForm());
	}

	return [{ loading, error }, handler];
}
